import actions from "@/store/modules/subcategory/actions";
import mutations from "@/store/modules/subcategory/mutations";
import state from "@/store/modules/subcategory/state";

export default {
    actions,
    mutations,
    state
}